import { c as _c } from "react/compiler-runtime";
import { PopoverPropertiesType } from "@website/ui/popover/popover.types";
import { MouseEvent, useEffect, useRef, useState } from "react";
export const usePopover = properties => {
  const $ = _c(21);
  const rootReference = useRef(null);
  const {
    "aria-describedby": ariaDescribedby,
    "aria-labelledby": ariaLabelledby,
    id,
    animate,
    open,
    onClose
  } = properties;
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [animateOpen, setAnimateOpen] = useState(false);
  let t0;
  let t1;
  if ($[0] !== animate || $[1] !== onClose || $[2] !== open) {
    t0 = () => {
      const checkIfClickedOutside = t2 => {
        const {
          target
        } = t2;
        if (open && rootReference.current && !rootReference.current.contains(target as Node)) {
          onClose();
        }
      };
      if (document) {
        if (open) {
          document.addEventListener("click", checkIfClickedOutside);
          setPopoverOpen(true);
          setTimeout(() => {
            setAnimateOpen(true);
          }, 0);
        } else {
          document.removeEventListener("click", checkIfClickedOutside);
          setAnimateOpen(false);
          setTimeout(() => {
            setPopoverOpen(false);
          }, animate === "normal" ? 0 : 75);
        }
      }
      return () => {
        if (document) {
          document.removeEventListener("click", checkIfClickedOutside);
        }
      };
    };
    t1 = [animate, onClose, open];
    $[0] = animate;
    $[1] = onClose;
    $[2] = open;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] !== onClose) {
    t2 = event => {
      event.stopPropagation();
      onClose();
    };
    $[5] = onClose;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const onCloseButtonClick = t2;
  const stopPropagationOnModal = _temp;
  let t3;
  if ($[7] !== ariaDescribedby || $[8] !== ariaLabelledby || $[9] !== id) {
    t3 = {
      "aria-labelledby": ariaLabelledby,
      "aria-describedby": ariaDescribedby,
      "aria-modal": true,
      onClick: stopPropagationOnModal,
      ref: rootReference,
      role: "dialog",
      tabIndex: 0,
      id
    };
    $[7] = ariaDescribedby;
    $[8] = ariaLabelledby;
    $[9] = id;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = animate === "normal" ? 0 : 75;
  let t5;
  if ($[11] !== t4) {
    t5 = {
      timeout: t4
    };
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== onCloseButtonClick) {
    t6 = {
      onClick: onCloseButtonClick
    };
    $[13] = onCloseButtonClick;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== animateOpen || $[16] !== popoverOpen || $[17] !== t3 || $[18] !== t5 || $[19] !== t6) {
    t7 = {
      rootProps: t3,
      transitionProps: t5,
      closeButtonProps: t6,
      popoverOpen,
      animateOpen
    };
    $[15] = animateOpen;
    $[16] = popoverOpen;
    $[17] = t3;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
function _temp(event_0) {
  event_0.stopPropagation();
}